import { type QueryKey } from "@tanstack/react-query";

import { getPrincipal } from "@/principal";

// Type alias for clarity
export type PrincipalKey = string;

export function serviceAccountPrincipalKey(serviceAccountId: string): PrincipalKey {
    return `sa/${serviceAccountId}`;
}

export function keyWithPrincipal(key: QueryKey, principal?: PrincipalKey): QueryKey {
    return ["principal", principal || getPrincipal(), ...key];
}
